<template>
  <div class="app-tariffoptions-wrapper">
    <div v-if="showBookableContent" class="bank-balance-info">
      <BalanceInfo>
        <template v-for="slot in possibleChildSlotsFor('BalanceInfo')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </BalanceInfo>
    </div>
    <div v-if="showBookableContent && forceUpdate" class="bookable-options">
      <BookableAccordion @select="onSelect" v-for="group in tariffPaketGroups"
                         :key="group.key"
                         :packets="group"
                         :fields="tariffOptionFields"
                         :open="openGroup"
      >
        <template v-for="slot in possibleChildSlotsFor('Package', group.key)" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </BookableAccordion>
    </div>
    <div v-if="!showBookableContent" class="bookable-options">
      <TariffoptionChangeBooking @view="onView"
                                 :selected="this.selectedItem"
                                 :item="this.item">
        <template v-for="slot in possibleChildSlotsFor('Change')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </TariffoptionChangeBooking>
    </div>
  </div>
</template>

<script>

import slotProxy from '@/mixins/slotProxy'
import extraData from '@/mixins/extraData'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import BookableAccordion from './BookableAccordion.vue'
import BalanceInfo from '../../Balance/BalanceInfo.vue'
import TariffoptionChangeBooking from '@/components/process/generic/Tariff/fyve/TariffoptionChangeBooking.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Tariffoptions',
  components: { TariffoptionChangeBooking, BalanceInfo, BookableAccordion },
  data () {
    return {
      changeToBookingProcess: false,
      selectedItem: {},
      tariffs: {},
      tariffoptions: {},
      serviceOptions: {},
      item: {},
      openGroup: null,
      groups: {
        Smart: 'Smart- und Kombi-Pakete',
        SurfOn: 'Surf-On-Pakete',
        Surf: 'Surf-Pakete',
        Unit: 'Einheiten-Pakete',
        Special: 'Spezial-Pakete',
        Service: 'Services'
      },
      tariffOptionFields: [
        { name: 'name', pos: 1 },
        { name: 'info', pos: 2 },
        { name: 'price', pos: 3 },
        { name: 'once', pos: 4 },
        { name: 'duration', pos: 5 }
      ]
    }
  },
  methods: {
    refresh () {
      this.$apollo.queries.tariffs.refresh()
    },
    onView (value) {
      this.changeToBookingProcess = value.back
      this.openGroup = value.key
      if (value.reload) {
        this.refresh()
      }
    },
    onSelect (value) {
      this.setItem(value.id, value.key)
      this.selectedItem = value
      this.changeToBookingProcess = true
    },
    setItem (id, key) {
      if (key === 'Smart') {
        this.item = this.availableTariffs.find(ele => ele.tariffId === id)
      } else if (key === 'Service') {
        this.item = this.availableService
      } else {
        this.item = this.availableTariffoptions.find(ele => ele.tariffOptionId === id)
      }
    },
    getPrice (key, item) {
      if (key === 'Smart') {
        return item.formattedBasicFee + ' pro ' + item.runtime.amount + ' ' + item.runtime.formattedUnit
      }
      return item.formattedPrice + ' pro ' + item.duration.amount + ' ' + item.duration.formattedUnit
    },
    getOnce (key, item) {
      if (key !== 'Smart' && key !== 'Service') {
        return item.automaticExtension ? null : '(einmalig)'
      }
    },
    buildItem (filteredItems, key) {
      if (key === 'Service') {
        return [{
          serviceId: filteredItems.serviceOptionId,
          key: key,
          name: filteredItems.name,
          info: filteredItems.extraInfoOrdering,
          price: filteredItems.price,
          duration: filteredItems.duration
        }]
      }
      const options = []
      filteredItems.forEach(function (item, index) {
        options[index] = {
          tariffOptionId: item.tariffoptionId,
          tariffId: item.tariffId,
          key: key,
          name: item.name,
          info: item.infoText,
          price: this.getPrice(key, item),
          once: this.getOnce(key, item)
        }
      }, this)
      return options.sort(function (a, b) {
        return a.tariffId - b.tariffId
      })
    },
    filterItems (key, value) {
      let filteredItems
      if (value === 'Smart- und Kombi-Pakete') {
        filteredItems = this.availableTariffs === null ? null : this.availableTariffs.filter(elem => elem.category === value)
      } else if (value === 'Services') {
        filteredItems = this.availableService
      } else if (value !== 'Smart- und Kombi-Pakete' && value !== 'Services') {
        filteredItems = this.availableTariffoptions === null ? null : this.availableTariffoptions.filter(elem => elem.category === value)
      }
      return filteredItems === null ? null : this.buildItem(filteredItems, key)
    }
  },
  computed: {
    ...mapGetters('tariffs', [
      'getForceUpdate'
    ]),
    forceUpdate: function () {
      if (this.getForceUpdate) {
        this.refresh()
        this.$store.commit('tariffs/forceUpdate', false)
      }
      return true
    },
    showBookableContent: function () {
      return !this.changeToBookingProcess
    },
    tariffPaketGroups: function () {
      const packetGroups = []
      for (const [key, value] of Object.entries(this.groups)) {
        packetGroups.push({
          key: key,
          items: this.filterItems(key, value)
        })
      }
      return packetGroups
    },
    availableTariffs: function () {
      const tariffs = this.tariffs?.bookableTariffs?.bookableTariffs
      if (tariffs) {
        return tariffs.map((tariff) => {
          const extra = this.extraData.find(elem => elem.tariffId === tariff.tariffId)
          return { ...extra, ...tariff }
        })
      }
      return null
    },
    availableTariffoptions: function () {
      const tariffOptions = this.tariffoptions?.bookableTariffoptions?.bookableTariffoptions
      if (tariffOptions) {
        return tariffOptions.map((option) => {
          const extra = this.extraData.find(elem => elem.tariffOptionId === option.tariffoptionId)
          return { ...extra, ...option }
        })
      }
      return null
    },
    availableService: function () {
      if (!this.serviceOptions?.anonymousCallRejection) {
        const extra = this.extraData.find(elem => elem.serviceOptionId === 'acr')
        return { ...extra, ...this.serviceOptions }
      }
      return null
    }
  },
  mixins: [slotProxy(), extraData()],
  apollo: {
    tariffs: function () {
      return wrapQuery(
        gql`query bookableTariffs {
          tariffs {
            bookableTariffs {
              bookableTariffs {
                tariffId
                name
                volumes {
                  amount
                  unit
                }
                formattedBasicFee
                basicFee
                runtime {
                  amount
                  formattedUnit
                }
              }
            }
          },
          tariffoptions {
            bookableTariffoptions {
              bookableTariffoptions {
                tariffoptionId
                name
                volumes {
                  amount
                  type
                }
                duration {
                  amount
                  formattedUnit
                }
                formattedPrice
                price
                automaticExtension
              }
            }
          },
          serviceOptions {
            anonymousCallRejection
          }
        }`, this, ['tariffs', 'tariffoptions', 'serviceOptions'], {}, function (data) {}
      )
    }
  }
}
</script>
